module.exports = __webpack_public_path__ + "static/media/DoorPaint_Before.6ed7d6dd.jpg";